import { c as _c } from "react/compiler-runtime";
import { Col, Container, Row } from "react-bootstrap";
import Image from "next/image";
export default function AboutMemeLab() {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Row><Col className="pt-2 pb-4"><Image unoptimized={true} loading="eager" priority={true} width="0" height="0" style={{
          width: "250px",
          height: "auto"
        }} src="/memelab.png" alt="memelab" /></Col></Row>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <p>The Meme Lab is an experimental CC0 contract for artists who have already minted a Meme Card. They can use the Meme Lab contract to mint NFTs that they like, in any way that they like.</p>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Container>{t0}<Row className="pt-3 pb-3"><Col>{t1}<p>We actively encourage the artists to experiment on any dimension they like on the Meme Lab's contract - artistic, community, edition size, price and so on.<br />We will learn more in the next 6 months about how artists plan to use it and what happens.</p><p>We hope to see some successes, and certainly expect there will be some failures too.</p></Col></Row></Container>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}